import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';

const GlobalLoader = ({ open }) => {
  return (
    <Backdrop
      sx={{ 
        color: '#ed6c02', // तुझा ऑरेंज कलर
        zIndex: 9999, // हा लोडर सर्वांच्या वर दिसावा म्हणून
        backgroundColor: 'rgba(255, 255, 255, 0.7)', // प्रीमियम लूकसाठी हलका पांढरा बॅकग्राउंड
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
      open={open}
    >
      <CircularProgress color="inherit" size={50} thickness={4} />
      <Typography 
        sx={{ 
          color: '#ed6c02', 
          fontWeight: 700, 
          letterSpacing: '1px' 
        }}
      >
        LOADING...
      </Typography>
    </Backdrop>
  );
};

export default GlobalLoader;